/* eslint-disable react/no-unused-state */
import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import dayjs from '../../utils/dayjs';
import { Popper, Manager, Reference } from 'react-popper';
import DayPicker from 'react-day-picker';
import TimePicker from './TimePicker';
import MLIcon from '../MLIcon';
import s from './MLDateTimePicker.module.css';

class MLDateTimePicker extends Component {
  static propTypes = {
    pickerType: PropTypes.string.isRequired,
    value: PropTypes.string,
    boxed: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func,
    closeOnChange: PropTypes.bool,
    disabled: PropTypes.bool,
    noIcon: PropTypes.bool,
    hasError: PropTypes.bool,
    testId: PropTypes.string,
    hourTestId: PropTypes.string,
    minuteTestId: PropTypes.string,
    amPmTestId: PropTypes.string,
  };

  static displayDate(value, format) {
    return dayjs(new Date(value)).format(format);
  }

  static checkDateFormat(dateStr) {
    return dayjs(dateStr, 'YYYY-MM-DD').isValid();
  }

  static checkTimeFormat(timeStr) {
    return dayjs(timeStr, 'HH:mm').isValid();
  }

  constructor(props) {
    super(props);
    const { value, pickerType } = props;
    let defaultDate = null;
    if (pickerType === 'date') {
      if (MLDateTimePicker.checkDateFormat(value)) {
        defaultDate = dayjs(value, 'YYYY-MM-DD').toDate();
      } else {
        const today = dayjs();
        defaultDate = new Date(today.year(), today.month(), today.date());
      }
    }

    /* To close calendar when click ouside of it */
    this.setDatePickerWrapperRef = this.setDatePickerWrapperRef.bind(this);
    this.handleClickOutsideCalendar =
      this.handleClickOutsideCalendar.bind(this);

    this.state = {
      showDatePicker: false,
      selectedDate: defaultDate,
      anchorInput: null,
      anchorInputId: uuidv4(),
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutsideCalendar);
  }

  componentDidUpdate(_prevProps, prevState) {
    const { selectedDate } = this.state;
    const { onChange, closeOnChange, pickerType } = this.props;
    if (pickerType === 'date') {
      if (prevState.selectedDate !== selectedDate) {
        const formatedDate = dayjs(new Date(selectedDate)).format('YYYY-MM-DD');
        onChange('dateChange', formatedDate);
        if (closeOnChange) this.toggleDatePicker();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideCalendar);
  }

  setDatePickerWrapperRef(node) {
    this.wrapperRef = node;
  }

  formatDateInput() {
    const { value, pickerType } = this.props;
    let defaultDate = null;
    if (pickerType === 'date') {
      if (MLDateTimePicker.checkDateFormat(value)) {
        defaultDate = dayjs(value, 'YYYY-MM-DD').toDate();
      } else {
        const today = dayjs();
        defaultDate = new Date(today.year(), today.month(), today.date());
      }
    }
    return defaultDate;
  }

  handleDateChange(date) {
    this.setState({ selectedDate: date });
  }

  handleClickOutsideCalendar(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showDatePicker: false });
    }
  }

  toggleDatePicker(forceClose = false) {
    let showDatePicker;
    let anchorInput;
    if (this.state.showDatePicker || forceClose) {
      showDatePicker = false;
      anchorInput = null;
    } else {
      showDatePicker = true;
      anchorInput = document.getElementById(this.state.anchorInputId) || null;
    }
    this.setState({ showDatePicker, anchorInput });
  }

  renderDatePicker() {
    return (
      <div
        className={s.DayPickerWrapper}
        tabIndex="-1"
        ref={this.setDatePickerWrapperRef}
      >
        <DayPicker
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          labels={{
            previousMonth: 'previous_month_button',
            nextMonth: 'next_month_button',
          }}
          classNames={{
            container: s.DayPicker,
            wrapper: s.DayPickerWrapper,
            interactionDisabled: s.DayPickerinteractionDisabled,
            navBar: s.DayPickerNavBar,
            navButtonPrev: `${s.DayPickerNavButton} ${s.DayPickerNavButtonPrev}`,
            navButtonNext: `${s.DayPickerNavButton} ${s.DayPickerNavButtonNext}`,
            navButtonInteractionDisabled:
              s.DayPickerNavButtonInteractionDisabled,
            month: s.DayPickerMonth,
            caption: s.DayPickerCaption,
            weekdays: s.DayPickerWeekdays,
            weekdaysRow: s.DayPickerWeekdaysRow,
            weekday: s.DayPickerWeekday,
            body: s.DayPickerBody,
            week: s.DayPickerWeek,
            day: s.DayPickerDay,
            footer: s.DayPickerFooter,
            todayButton: s.DayPickerTodayButton,
            today: s.DayPickerDayToday,
            selected: s.DayPickerDayDisabled,
            disabled: '',
            outside: s.DayPickerDayOutside,
          }}
          enableOutsideDays
          initialMonth={this.formatDateInput()}
          selectedDays={this.formatDateInput()}
          onDayClick={(date) => {
            this.handleDateChange(date);
          }}
        />
      </div>
    );
  }

  renderDatePickerInput() {
    const { boxed, className, disabled, noIcon, hasError, testId } = this.props;
    const dateFormat = 'MMM DD, YYYY';
    const boxedClass = boxed ? s.boxed : '';
    const selectedDate = this.formatDateInput();
    const errorClass = hasError ? s.error : '';

    return (
      <Manager>
        <div className={s.dateInputWrapper} tabIndex="-1">
          <Reference>
            {({ ref }) => (
              <div
                ref={ref}
                id={this.state.anchorInputId}
                className={`${className} ${s.container} ${boxedClass} ${s.dateContainer} ${errorClass}`}
              >
                <div className={s.iconContainer}>
                  <MLIcon
                    className={`${s.calendar} ${
                      disabled ? s.calendarDisabled : ''
                    }`}
                    type="calendar_open"
                    role="presentation"
                  />
                </div>
                <div className={s.inputContainer}>
                  <button
                    className={`${s.dateInputBtn} ${
                      disabled ? s.dateInputBtnDisabled : ''
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      this.toggleDatePicker();
                    }}
                    disabled={disabled}
                    data-test-id={testId}
                  >
                    <span className={s.dateInputBtnText}>
                      {MLDateTimePicker.displayDate(selectedDate, dateFormat)}
                      {!noIcon && (
                        <MLIcon
                          className={`${s.dateInputBtnIcon} ${
                            disabled ? s.dateInputBtnIconDisabled : ''
                          }`}
                          type="caret_down"
                          role="presentation"
                        />
                      )}
                    </span>
                  </button>
                </div>
              </div>
            )}
          </Reference>
          {this.state.showDatePicker && (
            <Popper
              target={this.target}
              tabIndex="-1"
              modifiers={{
                preventOverflow: { enabled: true },
                hide: { enabled: true },
                flip: { enabled: true },
              }}
            >
              {({ ref, style, placement }) => (
                <div
                  ref={ref}
                  style={_.assign({}, style, { zIndex: 1000 })}
                  data-placement={placement}
                >
                  {this.renderDatePicker()}
                </div>
              )}
            </Popper>
          )}
        </div>
      </Manager>
    );
  }

  renderTimePicker() {
    const {
      value,
      onChange,
      className,
      hourTestId,
      minuteTestId,
      amPmTestId,
      disabled,
    } = this.props;
    return (
      <TimePicker
        className={className}
        time={value}
        onChange={(time) => {
          onChange('timeChange', time);
        }}
        hourTestId={hourTestId}
        minuteTestId={minuteTestId}
        amPmTestId={amPmTestId}
        disabled={disabled}
      />
    );
  }

  render() {
    const { pickerType, value } = this.props;
    if (pickerType === 'date') {
      if (value) {
        if (MLDateTimePicker.checkDateFormat(value)) {
          return this.renderDatePickerInput();
        }
      } else {
        return this.renderDatePickerInput();
      }
    }
    if (pickerType === 'time') {
      if (value) {
        if (MLDateTimePicker.checkTimeFormat(value)) {
          return this.renderTimePicker();
        }
      } else {
        return this.renderTimePicker();
      }
    }
    return null;
  }
}

export default MLDateTimePicker;
